module.exports = __webpack_public_path__ + "assets/retina_CentroidOfQuadrilateralDetailed.1645288061b86501011c5766940aba48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CentroidOfQuadrilateralDetailed.png
// module id = 632
// module chunks = 0